import { createStore } from "vuex";
import actions from './actions'
import mutations from './mutations'
import state from './state'
import user from './modules/user';
import common from './modules/common';
import globalCache from './modules/globalCache';
import product from './modules/product';
import i18nModule from './modules/i18n';

export default createStore({
  actions,
  state,
  mutations, 
  modules: {
    user,
    common,
    globalCache,
    product,
    i18n:i18nModule
  },
});
